import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';

import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const StyledButton = styled(Button, {
  shouldForwardProp: muiPropForwarding('hasTopPadding')
})(({ theme, hasTopPadding }) => ({
  display: 'inline',
  minWidth: 0,
  padding: 0,
  whiteSpace: 'nowrap',
  [theme.breakpoints.up('xs')]: {
    paddingTop: hasTopPadding ? '15px' : 0,
    paddingBottom: '7px',
    paddingLeft: 0,
    paddingRight: 0,
    textTransform: 'none',
    borderRadius: 0
  }
}));

const MenuSectionsBarNavLink = ({
  fullWidth,
  dataTestId,
  children,
  ...rest
}) => {
  const { hasTopPadding } = rest;
  return (
    <StyledButton
      fullWidth={fullWidth}
      variant="text"
      data-testid={dataTestId}
      hasTopPadding={hasTopPadding}
    >
      {children}
    </StyledButton>
  );
};

MenuSectionsBarNavLink.defaultProps = {
  fullWidth: false
};
MenuSectionsBarNavLink.propTypes = {
  highlighted: PropTypes.bool,
  fullWidth: PropTypes.bool,
  dataTestId: PropTypes.string,
  children: PropTypes.node,
  hasBottomPadding: PropTypes.bool,
  hasTopPadding: PropTypes.bool
};

export default MenuSectionsBarNavLink;
